/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Resource Management (BYO, Managed, Inline)
 */
export type ResourceTypeEnum = 'UNKNOWN' | 'INLINE' | 'EXTERNAL_BYO' | 'MANAGED';

export const ResourceTypeEnum = {

    UNKNOWN: 'UNKNOWN' as ResourceTypeEnum,

    INLINE: 'INLINE' as ResourceTypeEnum,

    EXTERNAL_BYO: 'EXTERNAL_BYO' as ResourceTypeEnum,

    MANAGED: 'MANAGED' as ResourceTypeEnum
};

